import React, { Component } from 'react'
import { Link, Redirect } from 'react-router-dom'
import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/solid'
import IconPicker from '../UI/IconPicker'
import RenderHome from './RenderHome'
import LangPills from '../UI/LangPills'
import Loader from '../UI/Loader'
import EmptyFolder from '../UI/EmptyFolder'
import tools from '../../tools'

// Niveau 2 du drill-down /contenu : les catégories d'une rubrique (maquette v6, direction A)
class ContenuRubrique extends Component {
	constructor(props) {
		super(props)
		this.state = {
			group: null,
			categories: null,
			icons: null,
			theme: null,
			module: null,
			position: null,
			all_modules: null,
			all_categories: null,
			not_found: false,
			error: null,
			success: null,
			edit_open: false,
			edit_translations: [],
			edit_icon: null,
			edit_prev: null,
			edit_lang: this.props.lang_default,
			edit_error: null,
			edit_submitting: false
		}
		this.props.updateNavbarTitle('Contenu de mon app')
		this.name_length_max = 40
	}

	componentDidMount() {
		this.loadRubrique()
	}

	componentDidUpdate(prevProps) {
		if (prevProps.match.params.id !== this.props.match.params.id)
		{
			this.setState({ group: null, categories: null, module: null, not_found: false, error: null })
			this.loadRubrique()
		}
		else if (prevProps.categories !== this.props.categories && this.state.icons !== null && this.props.categories)
			this.setState({ categories: this._prepareCategories(this.props.categories, this.state.icons) })
	}

	// Filtre, trie et enrichit (icône de prévisualisation) les catégories de la rubrique
	_prepareCategories = (categories, icons) => {
		const group_id = this.props.match.params.id
		let list = []
		for (let i = 0; i < categories.length; i++)
		{
			if (categories[i].group === group_id)
				list.push(categories[i])
		}
		list.sort((a, b) => {
			return a.order - b.order
		})
		list = tools.clone(list)
		for (let i = 0; i < list.length; i++)
			list[i].prev = tools.getIconPreview(icons, list[i].icon, 'lineal', 'blank')
		return list
	}

	loadRubrique = () => {
		const group_id = this.props.match.params.id
		Promise.all([
			this.props.fetchGroups(),
			this.props.fetchCategoriesByGroup(group_id),
			this.props.fetchIcons(),
			this.props.fetchTheme(),
			this.props.fetchModules(),
			this.props.fetchCategories()
		])
		.then(([groups, categories, icons, theme, modules, all_categories]) => {
			let group = null
			for (let i = 0; i < groups.length; i++)
			{
				if (groups[i]._id === group_id)
				{
					group = groups[i]
					break
				}
			}
			if (!group)
			{
				this.setState({ not_found: true })
				return ;
			}
			let module = null
			let position = null
			const sorted = tools.clone(modules)
			sorted.sort((a, b) => {
				return a.order - b.order
			})
			for (let i = 0; i < sorted.length; i++)
			{
				if (sorted[i].type === "group" && sorted[i].values && sorted[i].values.group === group_id)
				{
					module = sorted[i]
					position = i + 1
					break
				}
			}
			this.setState({
				group: group,
				categories: this._prepareCategories(categories, icons),
				icons: icons,
				theme: theme,
				module: module,
				position: position,
				all_modules: sorted,
				all_categories: all_categories
			})
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de récupérer la rubrique", 1) })
			console.log(err)
		})
	}

	// Pastilles d'état des langues activées : verte = traduite, orange = manquante
	_langChips = (translations, fields) => {
		if (!this.props.langs)
			return null
		return (
			<span className="inline-flex flex-wrap">
				{this.props.langs.map((lang) => {
					const missing = (tools.getMissingLangs(translations, [lang], fields).length > 0)
					return (
						<span
							key={lang}
							title={(missing) ? "Traduction manquante" : "Traduite"}
							className={"text-xs font-bold uppercase rounded-md px-2 py-1 mr-1 " + ((missing) ? "bg-yellow-100 text-yellow-700" : "bg-green-50 text-green-700")}
						>{lang}{(missing) ? ' !' : ''}</span>
					)
				})}
			</span>
		)
	}

	// ---- Édition de la rubrique (nom par langue, icône) avec titres miroirs ----

	openEdit = () => {
		//préremplissage depuis la base : un renommage fait ailleurs pendant que l'écran était ouvert n'est plus écrasé à la sauvegarde
		this.props.fetchGroups()
		.then(groups => {
			let group = this.state.group
			for (let i = 0; i < groups.length; i++)
			{
				if (groups[i]._id === group._id)
				{
					group = groups[i]
					break
				}
			}
			this._openEditWith(group)
		})
		.catch(err => {
			console.log(err)
			this._openEditWith(this.state.group)
		})
	}

	_openEditWith = (group) => {
		this.setState({
			group: group,
			edit_open: true,
			edit_translations: tools.clone(group.translations),
			edit_icon: group.icon,
			edit_prev: tools.getIconPreview(this.state.icons, group.icon, 'lineal', 'blank'),
			edit_lang: this.props.lang_default,
			edit_error: null,
			edit_submitting: false
		})
	}

	closeEdit = () => {
		if (this.state.edit_submitting === true)
			return ;
		this.setState({ edit_open: false })
	}

	handleEditLang = (lang) => {
		this.setState({ edit_lang: lang })
	}

	handleEditName = (event) => {
		const value = event.target.value
		let translations = tools.clone(this.state.edit_translations)
		let found = false
		for (let i = 0; i < translations.length; i++)
		{
			if (translations[i].lang === this.state.edit_lang)
			{
				translations[i].name = value
				found = true
				break
			}
		}
		if (!found)
			translations.push({ lang: this.state.edit_lang, name: value })
		this.setState({ edit_translations: translations })
	}

	handleEditIcon = (icon) => {
		this.setState({ edit_icon: icon, edit_prev: tools.getIconPreview(this.state.icons, icon, 'lineal', 'blank') })
	}

	// Miroirs : le titre du module suit le nouveau nom là où il était vide ou identique à l'ancien nom
	_mirrorModuleTranslations = (module_translations, old_translations, new_translations) => {
		let result = tools.clone(module_translations)
		for (let i = 0; i < new_translations.length; i++)
		{
			const lang = new_translations[i].lang
			const new_name = new_translations[i].name
			const old_name = tools.getTranslationValue(old_translations, lang, 'name')
			let entry = null
			for (let j = 0; j < result.length; j++)
			{
				if (result[j].lang === lang)
				{
					entry = result[j]
					break
				}
			}
			if (!entry)
				result.push({ lang: lang, title: new_name })
			else if (!entry.title || entry.title === old_name)
				entry.title = new_name
		}
		return result
	}

	submitEdit = (event) => {
		event.preventDefault()
		if (this.state.edit_submitting === true)
			return ;
		const default_name = tools.getTranslationValue(this.state.edit_translations, this.props.lang_default, 'name').trim()
		if (default_name.length === 0)
		{
			this.setState({ edit_error: "Indiquez le nom (version " + this.props.lang_default.toUpperCase() + ")" })
			return ;
		}
		for (let i = 0; i < this.state.edit_translations.length; i++)
		{
			if (this.state.edit_translations[i].name && this.state.edit_translations[i].name.length > this.name_length_max)
			{
				this.setState({ edit_error: "Le nom ne doit pas dépasser " + this.name_length_max + " caractères (version " + this.state.edit_translations[i].lang.toUpperCase() + ")" })
				return ;
			}
		}
		if (!this.state.edit_icon)
		{
			this.setState({ edit_error: "Choisissez une icône" })
			return ;
		}
		const old_translations = tools.clone(this.state.group.translations)
		const old_default_name = tools.getTranslationValue(old_translations, this.props.lang_default, 'name')
		const new_translations = this.state.edit_translations
		this.setState({ edit_submitting: true, edit_error: null })
		//le formulaire n'édite que nom et icône : on n'envoie rien d'autre (pas d'écrasement des réglages faits ailleurs)
		this.props.updateGroup({
			_id: this.state.group._id,
			translations: new_translations,
			icon: this.state.edit_icon
		})
		.then(ret => {
			if (ret === false)
				return Promise.reject('update_group')
			if (this.state.module === null)
				return true
			//miroir sur le module de l'accueil : titre par langue + nom interne
			const module = this.state.module
			const mirrored = this._mirrorModuleTranslations(module.translations, old_translations, new_translations)
			const name = (!module.name || module.name === old_default_name) ? default_name : module.name
			return this.props.updateModule({
				_id: module._id,
				name: name,
				type: module.type,
				values: module.values,
				translations: mirrored
			})
		})
		.then(ret => {
			if (!ret)
				return Promise.reject('update_module')
			this.setState({ edit_open: false, edit_submitting: false, success: "La rubrique a été mise à jour (accueil compris)." })
			this.loadRubrique()
		})
		.catch(err => {
			console.log(err)
			const msg = (err === 'update_module') ?
				"La rubrique a été renommée mais son titre sur l'accueil n'a pas suivi. Réessayez, ou corrigez-le depuis l'écran Page d'accueil historique."
				:
				tools.default_error_msg("Impossible de modifier la rubrique", 1)
			this.setState({ edit_error: msg, edit_submitting: false })
		})
	}

	// Monte ou descend une catégorie d'une position (direction -1 ou +1)
	moveCategory = (index, direction) => {
		const target = index + direction
		if (target < 0 || target >= this.state.categories.length)
			return ;
		let categories = tools.clone(this.state.categories)
		const order_tmp = categories[index].order
		categories[index].order = categories[target].order
		categories[target].order = order_tmp
		const tmp = categories[index]
		categories[index] = categories[target]
		categories[target] = tmp
		this.setState({ categories: categories, error: null })
		this.props.updateCategoriesOrder(categories)
		.then(ret => {
			if (ret === false)
				this.setState({ error: tools.default_error_msg("Impossible de réordonner les catégories", 2) })
		})
		.catch(err => {
			this.setState({ error: tools.default_error_msg("Impossible de réordonner les catégories", 3) })
			console.log(err)
		})
	}

	render() {
		const permissions = this.props.user.permissions
		if (!permissions || !permissions.rubrics || permissions.rubrics === 0)
			return (<Redirect to="/" />)
		if (this.state.not_found === true)
			return (<Redirect to="/contenu" />)
		if (this.state.group === null || this.state.categories === null)
		{
			if (this.state.error !== null)
				return (<p className="error center">{this.state.error}</p>)
			return (
				<div className="loader">
					<Loader />
				</div>
			)
		}
		const group = this.state.group
		const categories = this.state.categories
		const name = tools.getTranslationValue(group.translations, this.props.lang_default, 'name')
		const group_icon = tools.getIconPreview(this.state.icons, group.icon, 'lineal', 'blank')
		const themeStyle = (this.state.theme && this.state.theme.color1) ? { backgroundColor: '#' + this.state.theme.color1 } : { backgroundColor: '#9CA3AF' }
		const hidden = (this.state.module) ? (this.state.module.hidden === true) : false
		return (
			<div className="wrapper-content">
				<p className="text-xs text-gray-400 mb-4">
					<Link to="/contenu" className="text-gray-500 hover:text-gray-900">Contenu de mon app</Link>
					<span className="mx-2 text-gray-300">/</span>
					<span className="text-gray-900 font-semibold">{name}</span>
				</p>
				<div className="flex flex-wrap items-start">
				<div className="flex-1" style={{ minWidth: '340px' }}>
				<div className="bg-white rounded-2xl shadow border border-gray-200 px-6 py-6 flex items-center flex-wrap mb-5">
					<div className="w-16 h-16 rounded-2xl flex-shrink-0 flex items-center justify-center" style={themeStyle}>
						{(group_icon) ? <img src={group_icon} className="w-9 h-9" alt="" /> : <span className="text-white text-2xl" aria-hidden="true">▦</span>}
					</div>
					<div className="flex-1 min-w-0 ml-5 mr-4">
						<h2 className="text-2xl font-bold tracking-tight text-gray-900 mb-0">
							{name}
							<span className="inline-flex items-center align-middle text-xs font-semibold bg-indigo-50 text-indigo-700 rounded-full px-3 py-1 ml-3">
								<span className="w-1.5 h-1.5 rounded-full bg-indigo-500 mr-1.5" aria-hidden="true"></span>Tuiles sur l'accueil
							</span>
							{(this.state.module) ?
								<span className={"inline-flex items-center align-middle text-xs font-semibold rounded-full px-3 py-1 ml-1.5 " + ((hidden) ? "bg-gray-100 text-gray-500 border border-dashed border-gray-300" : "bg-green-50 text-green-700")}>
									<span className={"w-1.5 h-1.5 rounded-full mr-1.5 " + ((hidden) ? "bg-gray-400" : "bg-green-500")} aria-hidden="true"></span>{(hidden) ? "Masquée" : "Visible"}
								</span>
								:
								<span className="inline-flex items-center align-middle text-xs font-semibold bg-gray-100 text-gray-500 border border-dashed border-gray-300 rounded-full px-3 py-1 ml-1.5">Pas encore sur l'accueil</span>
							}
						</h2>
						<p className="mt-2 text-sm font-medium text-gray-400 mb-0">
							Contient {categories.length} catégorie{(categories.length > 1) ? 's' : ''}
							{(this.state.position !== null) &&
								<span> · Position sur la home : {this.state.position}</span>
							}
						</p>
					</div>
					<div className="flex items-center">
						<button
							type="button"
							onClick={this.openEdit}
							className="text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg px-5 py-2.5 mr-2 hover:border-indigo-400"
							style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
						>Modifier &amp; Traduire</button>
						<button
							type="button"
							disabled
							title="Les actions (supprimer, masquer) sont dans le menu ⋯ de l'écran Contenu"
							aria-label="Plus d'actions"
							className="text-sm font-bold text-gray-400 border border-gray-300 rounded-lg px-3.5 py-2.5 cursor-not-allowed"
							style={{ backgroundImage: 'none', backgroundColor: '#F9FAFB' }}
						>⋯</button>
					</div>
				</div>
				{this.state.success !== null &&
					<div className="flex items-center justify-between bg-green-50 border border-green-200 text-green-800 text-sm font-medium rounded-xl px-4 py-3 mb-4">
						<span>✓ {this.state.success}</span>
						<button
							type="button"
							onClick={() => this.setState({ success: null })}
							aria-label="Fermer"
							className="text-green-700 font-bold ml-4"
							style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
						>✕</button>
					</div>
				}
				{this.state.error !== null &&
					<p className="error center">{this.state.error}</p>
				}
				{(!categories.length) &&
					<EmptyFolder emptyFolderSubtitle="Cette rubrique n'a pas encore de catégorie." />
				}
				<div className="bg-white rounded-2xl shadow border border-gray-200 divide-y divide-gray-100 overflow-hidden">
					<div className="hidden md:flex items-center px-5 py-2 bg-gray-50 text-xs uppercase tracking-wide text-gray-400 font-semibold">
						<span className="w-5 mr-4 text-right">N°</span>
						<span className="w-10 mr-4"></span>
						<span className="flex-1">Catégorie</span>
						<span className="w-32 ml-4">Format</span>
						<span className="w-48 ml-4">État des langues</span>
						<span className="w-28 ml-4 text-right">Actions</span>
					</div>
					{categories.map((category, index) => {
						const cat_name = tools.getTranslationValue(category.translations, this.props.lang_default, 'name')
						const is_list = (category.type === "list")
						return (
							<Link
								key={category._id}
								to={"/contenu/categorie/" + category._id}
								className="flex items-center px-5 py-4 hover:bg-gray-50 transition-colors group"
							>
								<span className="w-5 text-right text-sm font-semibold text-gray-400 tabular-nums flex-shrink-0 mr-4">{index + 1}</span>
								<div className="w-10 h-10 rounded-xl flex-shrink-0 flex items-center justify-center mr-4" style={themeStyle}>
									{(category.prev) ? <img src={category.prev} className="w-6 h-6" alt="" /> : <span className="text-white text-sm" aria-hidden="true">▭</span>}
								</div>
								<div className="flex-1 min-w-0">
									<p className="text-base font-bold text-gray-900 truncate mb-0">{cat_name}</p>
								</div>
								<span className="w-32 ml-4 flex-shrink-0">
									<span className={"inline-flex items-center text-xs font-semibold uppercase tracking-wide rounded-full px-3 py-1 " + ((is_list) ? "bg-purple-50 text-purple-700" : "bg-green-50 text-green-700")}>
										<span className={"w-1.5 h-1.5 rounded-full mr-1.5 " + ((is_list) ? "bg-purple-500" : "bg-green-500")} aria-hidden="true"></span>
										{(is_list) ? "Liste" : "Page"}
									</span>
								</span>
								<span className="w-48 ml-4 flex-shrink-0">
									{this._langChips(category.translations, ['name'])}
								</span>
								<div className="w-28 ml-4 flex items-center justify-end flex-shrink-0">
									<div className="flex flex-col">
										<button
											type="button"
											onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.moveCategory(index, -1) }}
											disabled={index === 0}
											aria-label="Monter"
											className={"p-0.5 rounded " + ((index === 0) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										><ChevronUpIcon className="h-4 w-4" /></button>
										<button
											type="button"
											onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.moveCategory(index, 1) }}
											disabled={index === categories.length - 1}
											aria-label="Descendre"
											className={"p-0.5 rounded " + ((index === categories.length - 1) ? "text-gray-200 cursor-default" : "text-gray-400 hover:text-gray-700 hover:bg-gray-100")}
											style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
										><ChevronDownIcon className="h-4 w-4" /></button>
									</div>
									<span className="text-sm font-bold text-gray-600 group-hover:text-indigo-600 ml-2 whitespace-nowrap">Ouvrir ›</span>
								</div>
							</Link>
						)
					})}
					<div
						className="flex items-center justify-center px-5 py-4 cursor-not-allowed"
						title="Disponible dans un prochain lot"
						style={{ backgroundColor: '#FBFBFC' }}
					>
						<span className="inline-flex items-center text-sm font-semibold text-gray-400 border-2 border-dashed border-gray-300 rounded-lg px-5 py-2">
							<span className="mr-2" aria-hidden="true">+</span>Ajouter une catégorie
						</span>
					</div>
				</div>
				</div>
				<div className="flex-shrink-0 ml-8 sticky top-4" style={{ width: '300px' }}>
					<p className="text-xs font-bold uppercase tracking-wide text-green-700 mb-2 flex items-center">
						<span className="w-1.5 h-1.5 rounded-full bg-green-500 mr-1.5" aria-hidden="true"></span>
						Aperçu en direct (vacancier)
					</p>
					<div className="rounded-3xl bg-gray-900 p-2 shadow-xl">
						<div className="w-10 h-1 rounded-full bg-gray-700 mx-auto mb-1.5" aria-hidden="true"></div>
						<div className="rounded-2xl bg-white" style={{ height: '600px', overflow: 'hidden' }}>
							{/* rendu à largeur native 375px puis réduit — même technique que l'aperçu des pages */}
							<div style={{ width: '375px', height: '792px', transform: 'scale(0.757)', transformOrigin: 'top left', overflowY: 'auto' }}>
								<RenderHome
									modules={this.state.all_modules}
									categories={this.state.all_categories}
									icons={this.state.icons}
									theme={this.state.theme}
									lang={this.props.lang_default}
								/>
							</div>
						</div>
					</div>
					<p className="text-xs text-gray-400 mt-2 mb-0">La home complète, avec cette rubrique à sa place. Les photos des cartes sont figurées par la couleur du thème.</p>
				</div>
				</div>
				{this.state.edit_open === true &&
					<div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto" role="dialog" aria-modal="true" aria-label="Modifier la rubrique">
						<div className="fixed inset-0 bg-black bg-opacity-40" onClick={this.closeEdit}></div>
						<div className="relative bg-white rounded-2xl shadow-xl w-full mx-4 my-16 px-6 py-6" style={{ maxWidth: '540px' }}>
							<div className="flex items-start justify-between mb-4">
								<h3 className="text-lg font-bold text-gray-900 mb-0">Modifier la rubrique</h3>
								<button
									type="button"
									onClick={this.closeEdit}
									aria-label="Fermer"
									className="text-gray-400 hover:text-gray-700 font-bold text-lg leading-none"
									style={{ backgroundImage: 'none', backgroundColor: 'transparent', border: 'none', boxShadow: 'none' }}
								>✕</button>
							</div>
							<div className="mb-4">
								<LangPills
									langs={this.props.langs}
									translations={this.state.edit_translations}
									fields={['name']}
									current={this.state.edit_lang}
									onSelect={this.handleEditLang}
								/>
							</div>
							<form onSubmit={this.submitEdit}>
								<label className="block mb-4">
									<span className="flex justify-between items-baseline flex-wrap">
										<span className="text-xs font-semibold text-gray-600 mb-1">Nom ({this.state.edit_lang.toUpperCase()})</span>
										{(this.state.edit_lang !== this.props.lang_default) &&
											<span className="text-xs text-gray-400">Référence {this.props.lang_default.toUpperCase()} : « {tools.getTranslationValue(this.state.edit_translations, this.props.lang_default, 'name')} »</span>
										}
									</span>
									<input className="input-modern w-full" type="text" value={tools.getTranslationValue(this.state.edit_translations, this.state.edit_lang, 'name')} onChange={this.handleEditName} autoFocus />
									<span className="block text-xs text-green-700 mt-1">✓ Le titre sur l'accueil suivra automatiquement (sauf s'il avait été personnalisé).</span>
								</label>
								<div className="mb-4">
									<p className="text-xs font-semibold text-gray-600 mb-1">Icône :</p>
									<div className="flex items-center">
										{this.state.edit_prev &&
											<span className="w-9 h-9 rounded-lg flex items-center justify-center mr-3 flex-shrink-0" style={themeStyle}>
												<img src={this.state.edit_prev} className="w-6 h-6" alt="Icône choisie" />
											</span>
										}
										<IconPicker type="lineal" theme="blank" icons={this.state.icons} onChange={this.handleEditIcon} />
									</div>
								</div>
								{this.state.edit_error &&
									<p className="text-xs text-red-600 font-medium mt-3 mb-0">{this.state.edit_error}</p>
								}
								{(this.state.edit_submitting === true) ?
									<div className="center mt-4">
										<Loader />
									</div>
									:
									<div className="flex justify-end pt-4 mt-4 border-t border-gray-100">
										<button
											type="button"
											onClick={this.closeEdit}
											className="text-sm font-semibold text-gray-600 bg-white border border-gray-300 rounded-lg px-4 py-2 mr-2"
											style={{ backgroundImage: 'none', backgroundColor: '#fff' }}
										>Annuler</button>
										<button
											type="submit"
											className="text-sm font-semibold text-white rounded-lg px-5 py-2"
											style={{ backgroundImage: 'none', backgroundColor: '#4F46E5' }}
										>Enregistrer</button>
									</div>
								}
							</form>
						</div>
					</div>
				}
			</div>
		)
	}
}

export default ContenuRubrique
